import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pub-opening',
  templateUrl: './pub-opening.component.html',
  styleUrls: ['./pub-opening.component.css']
})
export class PubOpeningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
